import Icon from "./Icon";
import * as React from "react";
class Toggle extends React.PureComponent {
    render() {
        const { children, checked, disabled } = this.props;
        const classes = ["toggle-container"];
        if (disabled === true) {
            classes.push("toggle-disabled");
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: classes.join(" ") },
                React.createElement("div", { className: `toggle toggle-${checked ? "on" : "off"}`, onClick: disabled === true ? undefined : this.onToggle },
                    React.createElement("div", { className: "toggle-track" },
                        React.createElement(Icon, { name: checked ? "toggle-enabled" : "toggle-disabled" })),
                    React.createElement("div", { className: "toggle-handle" },
                        React.createElement(Icon, { name: "riffle", rotate: 90 }))),
                React.createElement("div", { className: "toggle-children" }, children))));
    }
    onToggle = () => {
        const { onToggle, checked, dataId } = this.props;
        onToggle(!checked, dataId);
    };
}
export default Toggle;
